import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { SuccessResponse } from '../../../shared/success-response';
import { IDiscountSummaryApiService } from './discount-summary-api.interface';
import { ExportExcelPdfService } from '../../../export-excel-pdf/export-excel-pdf.service';
import { HandleBlobHttpResponseOptions } from '@orderna/admin-panel/src/types/handle-blob-http-response-options';
import { SALES_ANALYTICS_API_URL } from '../sales-analytics-api.constants';
import { ExportDiscountSummaryQueryDto } from './dtos/export-discount-summary.query.dto';
import { FindDiscountSummaryQueryDto } from './dtos/find-discount-summary.query.dto';
import { FindDiscountSummaryResponseDto } from './dtos/find-discount-summary.response.dto';

@Injectable({
  providedIn: 'root',
})
export class DiscountSummaryApiService
  implements IDiscountSummaryApiService
{
  private readonly ENDPOINT = 'discount-summary';

  private http = inject(HttpClient);
  private exportService = inject(ExportExcelPdfService);

  async findDiscountSummary(
    query: FindDiscountSummaryQueryDto
  ): Promise<FindDiscountSummaryResponseDto> {
    const params = new HttpParams({ fromObject: query as any });

    const response = await firstValueFrom(
      this.http.get<SuccessResponse<FindDiscountSummaryResponseDto>>(
        `${SALES_ANALYTICS_API_URL}/${this.ENDPOINT}`,
        { params }
      )
    );

    return response.data;
  }

  exportDiscountSummary(
    query: ExportDiscountSummaryQueryDto,
    options?: HandleBlobHttpResponseOptions
  ) {
    const { print = false } = options ?? {};
    const params = new HttpParams({ fromObject: query as any });

    this.exportService.export({
      endpoint: this.ENDPOINT,
      params,
      print,
    });
  }
}
